'use es6';

import { useMemo, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import UIInlineLabel from 'UIComponents/form/UIInlineLabel';
import UISelect from 'UIComponents/input/UISelect';
import * as FilterKey from '../../constants/search/FilterKey';
import { SORT_FIELD_ORDER } from '../../constants/search';
import * as SortField from '../../constants/search/SortField';
import { updateStorefrontFilters } from '../../slices/storefrontFiltersSlice';
import { getTranslatedSortText } from '../../utils/i18n';
import StorefrontUsageTrackerContext from '../../context/StorefrontUsageTrackerContext';
import { getHasFilters } from '../../utils/filters';
import { jsx as _jsx } from "react/jsx-runtime";
const textPath = 'ecosystem-marketplace-solutions-ui.storefront.results.sort';
const ValueComponent = ({
  children
}) => /*#__PURE__*/_jsx("span", {
  role: "button",
  children: children
});
const SortDropdown = ({
  filters
}) => {
  const dispatch = useDispatch();
  const {
    trackInteraction
  } = useContext(StorefrontUsageTrackerContext);
  const sortOptions = useMemo(() => {
    const hasFilters = getHasFilters(filters);
    return SORT_FIELD_ORDER.filter(sort => sort !== SortField.RELEVANCE_DESC || hasFilters).map(sort => {
      return {
        text: getTranslatedSortText(sort),
        value: sort
      };
    });
  }, [filters]);
  const handleSortChange = useCallback(evt => {
    const sort = evt.target.value;
    dispatch(updateStorefrontFilters({
      updates: {
        [FilterKey.SORTS]: sort
      }
    }));
    trackInteraction('change sort', {
      sortField: sort
    });
  }, [dispatch, trackInteraction]);
  const buttonProps = useResponsiveProps({
    anchorType: {
      xs: 'button',
      sm: 'auto'
    },
    buttonSize: {
      xs: 'sm',
      sm: undefined
    },
    buttonUse: {
      xs: 'tertiary-light',
      sm: 'transparent'
    },
    className: {
      xs: undefined,
      sm: 'p-right-0'
    }
  });
  return /*#__PURE__*/_jsx(UIInlineLabel, {
    className: "m-right-0",
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${textPath}.label`
    }),
    children: /*#__PURE__*/_jsx(UISelect, Object.assign({}, buttonProps, {
      menuWidth: "auto",
      onChange: handleSortChange,
      options: sortOptions,
      placement: "bottom left",
      value: filters[FilterKey.SORTS],
      valueComponent: ValueComponent
    }))
  });
};
SortDropdown.propTypes = {
  filters: PropTypes.object.isRequired
};
export default SortDropdown;